<template>
  <pt-health-record-detail class="pt-health-record-detail__withData" :id="id" :healthRecordDetail="healthRecordDetail"></pt-health-record-detail>
</template>

<script>
import PtHealthRecordDetail from './index'
export default {
  name: 'pt-health-record-detail__withData',
  components: {
    'pt-health-record-detail': PtHealthRecordDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      healthRecordDetail: {}
    }
  },
  methods: {
    getHealthRecordDetail () {
      this.$store.dispatch('getHealthRecordDetail', this.id).then(res => {
        this.healthRecordDetail = res
      }).catch(err => {
        this.$message(err || '获取健康档案详情失败')
      })
    }
  },
  created () {
    this.getHealthRecordDetail()
  }
}
</script>
